import { useState, useEffect } from "react";
import { Phone, MessageSquare } from "lucide-react";
import { toast } from "sonner";

const PHONE = "+916239547599";
const WA_URL = "https://wa.me/919041344420?text=Hi%20Prospera%2C%20I%20visited%20your%20website%20and%20I%27m%20interested%20in%20your%20services.%20Can%20we%20have%20a%20quick%20chat%3F";

export default function SmritiChat() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setIsMobile(/iPhone|iPad|iPod|Android/i.test(navigator.userAgent));
  }, []);

  return (
    <div className="fixed bottom-6 right-6 flex flex-col gap-3" style={{ zIndex: 9998 }}>
      <button onClick={() => window.open(WA_URL, "_blank")} data-testid="quick-wa-btn"
        className="w-14 h-14 rounded-full border-2 border-white/20 hover:border-white/50 shadow-2xl shadow-black bg-black flex items-center justify-center cursor-pointer transition-colors">
        <MessageSquare className="w-5 h-5 text-white" />
      </button>
      {isMobile && (
        <button onClick={() => { window.location.href = `tel:${PHONE}`; }} data-testid="quick-call-btn"
          className="w-14 h-14 rounded-full border-2 border-white/20 hover:border-white/50 shadow-2xl shadow-black bg-black flex items-center justify-center cursor-pointer transition-colors">
          <Phone className="w-5 h-5 text-white" />
        </button>
      )}
    </div>
  );
}
